import {$post, $get} from '../utils/request'


export const $chaifenkecheng=async(params)=>{ 
    console.log("分课开始")
    console.log(params)
    let res=await $post('chaifenkecheng.do',params);
    console.log(res)
    console.log("分课结束")
    return res;

}   

export const $deleteUploadImage=async(params)=>{ 
    console.log("删除上课图片开始")
    console.log(params)
    let res=await $post('deleteUploadImage.do',params);
    console.log(res)
    console.log("删除上课图片结束")
    return res;

}
export const $addUploadImage=async(params)=>{ 
    console.log("上传上课图片开始")
    console.log(params)
    let res=await $post('addUploadImage.do',params);
    console.log(res)
    console.log("上传上课图片结束")
    return res;

}
export const $getDakaImageList=async(params)=>{
    console.log("查询预约上课图片开始")
    console.log(params)
    let res=await $post('getDakaImages.do',params);
    console.log(res)
    return res;
}
export const $tuisong=async(params)=>{
    console.log("修改推送状态开始")
    console.log(params)
    let res=await $post('tuisong.do',params);
    console.log(res)
    return res;
}


//查询预约信息列表
export const $fetchReservationList=async(params)=>{
    console.log("查询预约信息开始")
    console.log(params)
    let res=await $post('fetchReservationList.do',params);
    return res;
}

export const $getBaomingList=async(params)=>{
    console.log("查询预约信息开始")

    console.log(params)
    let res=await $post('getBaomingList.do',params);
    console.log("查询预约信息结束")
    return res;
}





/**
 * 
 * @param {新增预约} params 
 * @returns 
 */
export const $updateYuyue= async(params)=>{
    console.log("提交预约信息开始")

    console.log(params)
    let res=await $post('updateYuyue.do',params);
    console.log(res)
    console.log("提交预约信息结束")
    return res;
}


